<template>
  <div>
    <div v-if="PARISH_EXISTS">
      <v-row no-gutters class="mb-2">
        <span class="body-2 font-weight-medium">This Parish is already subscribed to Parish Online.</span>
      </v-row>
      <v-row no-gutters class="mb-2">
        <span class="body-2">If you think this is wrong, please <a href="https://www.parish-online.co.uk/support" target="_blank" class="font-weight-medium">contact us</a>.</span>
      </v-row>
      <v-row no-gutters>
        <span class="body-2">If you've forgotten your password or want to log in, click here.</span>
      </v-row>
    </div>

    <div v-else>
      <v-row no-gutters class="mb-2">
        <span class="body-2 font-weight-medium">Select how you want to Sign-Up</span>
      </v-row>
      <v-row>
        <v-col>
          <trial-card @select="selectTrial"></trial-card>
        </v-col>
        <v-col>
          <subscription-card @select="selectSubscription"></subscription-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import TrialCard from "@/components/TrialCard";
  import SubscriptionCard from "@/components/SubscriptionCard";

  export default {
    name: "StepTwo",
    components: {SubscriptionCard, TrialCard},
    props: {},
    data() {
      return {}
    },
    computed: {
      ...mapGetters({
        PARISH: 'GET_SELECTED_PARISH',
        PARISH_EXISTS: 'GET_PARISH_EXISTS'
      }),
    },
    methods: {
      selectTrial() {
        this.$store.commit('SET_SIGNUP_TYPE', 'TRIAL');
        this.$emit('next');
      },
      selectSubscription() {
        this.$store.commit('SET_SIGNUP_TYPE', 'SUBSCRIPTION');
        this.$emit('next');
      },
    },
  }
</script>
